import React from 'react'
import { NavLink } from 'react-router-dom'

const Navbar = () => {
  return (
    <div className="bg-blue-200 h-12 flex items-center">
      <div className="container mx-auto px-4">
        <ul className="flex flex-wrap justify-center gap-4 sm:gap-6 md:gap-10 text-base sm:text-base text-gray-700 font-bold">

          <li>
            <NavLink to="/contact" className="hover:text-red-700 transition-all duration-200">
              CONTACT US
            </NavLink>
          </li>

          <li>
            <NavLink to="/privacy" className="hover:text-red-700 transition-all duration-200">
              PRIVACY POLICY
            </NavLink>
          </li>

          <li>
            <NavLink to="/paper" className="hover:text-red-700 transition-all duration-200">
              E-PAPER
            </NavLink>
          </li>

          <li>
            <NavLink to="/advertise" className="hover:text-red-700 transition-all duration-200">
              ADVERTISE WITH US
            </NavLink>
          </li>

          <li>
            <NavLink to="/login" className="hover:text-red-700 transition-all duration-200">
              <button>Login</button>
            </NavLink>
          </li>
          
        </ul>
      </div>
    </div>
  )
}

export default Navbar
